var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChiuse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 33,
    viewBox: "0 0 92 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_102",
    "data-name": "Raggruppa 102",
    transform: "translate(-1024 -112)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_141",
    "data-name": "Rettangolo 141",
    width: 92,
    height: 33,
    transform: "translate(1024 112)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Orion_lock",
    transform: "translate(1051.118 114.251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Unione_7",
    "data-name": "Unione 7",
    d: "M3658.882-2669.753a4,4,0,0,1-4-4v-6.744a4,4,0,0,1,3.924-4v-5.41a6.352,6.352,0,0,1,6.344-6.345,6.352,6.352,0,0,1,6.344,6.345v5.41a4.005,4.005,0,0,1,3.924,4v6.744a4,4,0,0,1-4,4Zm-2-10.743v6.744a2,2,0,0,0,2,2h12.536a2,2,0,0,0,2-2v-6.744a2,2,0,0,0-2-2h-12.536A2,2,0,0,0,3656.882-2680.5Zm12.613-4v-5.409a4.349,4.349,0,0,0-4.344-4.344,4.349,4.349,0,0,0-4.345,4.344v5.409Z",
    transform: "translate(-3646.269 2697.251)",
    fill: "#8b8d8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "layer1",
    d: "M32,46.111a1,1,0,0,1-1-1V41a1,1,0,1,1,2,0v4.111A1,1,0,0,1,32,46.111Z",
    transform: "translate(-13.118 -22.967)",
    fill: "#202020"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChiuse);
export default __webpack_public_path__ + "static/media/Chiuse.a2dcba1c44b1518e44faabb0f08c41e1.svg";
export { ForwardRef as ReactComponent };